import React, { useState } from "react";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import { useNavigate } from "react-router-dom";

export default function ContactForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const sendRequest = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        "https://checkapi.allowbk.com/verify_link/send.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );

      const data = await response.json();
      setLoading(false);

      if (response.ok && data.success) {
        setFormData({ name: "", email: "", message: "" });
        await Swal.fire({
          icon: "success",
          title: "Message envoyé !",
          text: "Nous avons bien reçu votre message et vous répondrons dans les plus brefs délais.",
          showConfirmButton: true,
          confirmButtonText: "Accueil",
          customClass: { confirmButton: "btn btn-primary" },
        }).then((result) => {
          if (result.isConfirmed) {
            navigate("/");
          }
        });
      } else {
        const errorMsg = data.error || "Échec de l'envoi du message.";
        await Swal.fire({
          icon: "error",
          title: "Erreur",
          text: "Échec de l'envoi du message.Msg",
          showConfirmButton: true,
          confirmButtonText: "Ressayer plus tard",
          customClass: { confirmButton: "btn btn-primary" },
        }).then((result) => {
          if (result.isConfirmed) {
            navigate("/");
          }
        });
      }
    } catch (error) {
      setLoading(false);
      await Swal.fire({
        icon: "error",
        title: "Erreur réseau",
        text: error.message || "Une erreur est survenue.",
        showConfirmButton: true,
        confirmButtonText: "Ressayer plus tard",
        customClass: { confirmButton: "btn btn-primary" },
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("/");
        }
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    sendRequest();
  };

  return (
    <div className="container mt-2 mb-3 ">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className=" border-0 bg-transparent">
            <div className="card-body">
              {/* Bouton Retour en haut */}
              <div className="d-flex  mb-2">
                <button
                  type="button"
                  className="btn btn-outline-danger "
                  onClick={() => navigate("/")}
                >
                  <i class="fa-solid fa-left-long"></i> Retour
                </button>
              </div>
              <h4 className="card-title text-center mb-4 mt-3">Formulaire de contacte</h4>
              <form onSubmit={handleSubmit} className="px-1">
                <div className="mb-3">
                  <label htmlFor="name" className="form-label">
                    Nom
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    className="form-control"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="email" className="form-label">
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    className="form-control"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="message" className="form-label">
                    Message
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    className="form-control"
                    rows="4"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  />
                </div>

                <button
                  type="submit"
                  className="btn btn-primary w-100"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>{" "}
                      Envoi...
                    </>
                  ) : (
                    "Envoyer"
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
